<div class="header-label">
  <h2>RRE Linking</h2>
</div>

<div class="top-controls-row">
  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input
      matInput
      [value]="searchTerm"
      (input)="onSearch(($any($event.target)).value)"
      placeholder="Type to search..."
      autocomplete="off"/>
    <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <button mat-flat-button color="primary" type="button" class="top-controls-action-btn" (click)="onAddLink()">Add Link</button>
</div>

<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading">
  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir" class="rre-linking-table">
    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Office</th>
      <td mat-cell *matCellDef="let row">{{ row.Office }}</td>
    </ng-container>

    <ng-container matColumnDef="officeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Office Name</th>
      <td mat-cell *matCellDef="let row">{{ row.OfficeName }}</td>
    </ng-container>

    <ng-container matColumnDef="rre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>RRE</th>
      <td mat-cell *matCellDef="let row">{{ row.RRE }}</td>
    </ng-container>

    <ng-container matColumnDef="rreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>RRE Name</th>
      <td mat-cell *matCellDef="let row">{{ row.RREName }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="no-header"></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        <button
          mat-icon-button
          type="button"
          matTooltip="Delete"
          class="table-action-btn table-action-delete"
          (click)="deleteLink(row)"
          [attr.aria-label]="'Delete link for office ' + row.Office"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div *ngIf="!loading && dataSource.data.length === 0" class="no-results-message">
    No RRE links found
  </div>
</div>

<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizes"
  (page)="onPageChange($event)"
  showFirstLastButtons
></mat-paginator>


